import { render, staticRenderFns } from "./PageSugestoes.vue?vue&type=template&id=dff5ec90&"
import script from "./PageSugestoes.vue?vue&type=script&lang=js&"
export * from "./PageSugestoes.vue?vue&type=script&lang=js&"
import style0 from "./PageSugestoes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports